import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../services/firebase";
import { ReactComponent as FileIcon } from '../../assets/icons/FileIcon.svg';
import LoadingSpinner from "../LoadingSpinner";
import EmptyState from "../EmptyState";
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/react';
import {
getStorage,
ref,
getDownloadURL,
listAll,
} from "firebase/storage";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import { useCotizaciones, aPesos } from "../../services/cotizaciones";
import { ReactComponent as EditIcon } from '../../assets/icons/EditIcon.svg';
import ConfirmationModal from '../ContactSideBar/ConfirmationModal';
const categorias = [
"Activos",
"Almacén",
"Depósito",
"Enología",
"Finca",
"Insumos",
"Servicios",
"Utilitarios",
"Órdenes de compra",
];
const storage = getStorage();
// Fuera del componente para que sobreviva a que se desmonte al navegar (ej.
// al editar una compra y volver): guarda la última lista bajada de Firestore
// para poder mostrarla de entrada la próxima vez, en vez de arrancar siempre
// en blanco con el spinner tapando la pantalla mientras se vuelve a bajar.
let comprasCache = null;
const Tooltip = ({ doc, children, type = "nombre", delay = 250, offsetX = 0, offsetY = 0 }) => {
const [isHovered, setIsHovered] = useState(false);
const [coords, setCoords] = useState({ top: 0, left: 0 });
const ref = React.useRef();
const timeoutRef = React.useRef();
const formatDateTime = (fecha) => {
if (!fecha) return "-";
const date = fecha.toDate ? fecha.toDate() : new Date(fecha);
const day = String(date.getDate()).padStart(2, "0");
const month = String(date.getMonth() + 1).padStart(2, "0");
const year = date.getFullYear();
const hours = String(date.getHours()).padStart(2, "0");
const minutes = String(date.getMinutes()).padStart(2, "0");
return `el ${day}/${month}/${year} a las ${hours}:${minutes}`;
};
const handleMouseEnter = () => {
const rect = ref.current.getBoundingClientRect();
setCoords({
top: rect.bottom + window.scrollY + 5 + offsetY,
left: rect.left + rect.width / 2 + window.scrollX + offsetX,
});
timeoutRef.current = setTimeout(() => setIsHovered(true), delay);
};
const handleMouseLeave = () => {
clearTimeout(timeoutRef.current);
setIsHovered(false);
};
const renderContent = () => {
switch (type) {
case "nombre":
return (
<>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
<div>
<strong style={{color: '#999', fontSize:'13px', fontFamily:'Effra', fontWeight:'normal'}}>
{doc.personeria === "persona fisica"
? `${(doc.apellido || '').toUpperCase()}, ${doc.nombre || ""}`
: doc.razonSocial || ""}
</strong></div>
<div style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra'}}>
Creado por:
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{doc.creador || "-"}</p>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{formatDateTime(doc.fechaCreacion)}</p>
{doc.modificador && (
<>
<hr style={{borderColor:'#ebeef2'}}></hr>
Modificado por:
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{doc.modificador || "-"}</p>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{formatDateTime(doc.fecha_modificacion || doc.ultimaActualizacion)}</p>
</>
)}</div>
</div>
</>
);
case "domicilio":
return (
<>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px',textAlign:'left' }}>
<div>
<strong style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra',textAlign:'left', fontWeight:'normal'}}>
{doc.calle}  {doc.altura}, {doc.piso}{doc.unidad}
</strong></div>
<div style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra', textAlign:'left'}}>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}> {doc.codigoPostal}</p>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}> {doc.ciudad}, {doc.pais}</p>
</div>
</div>
</>
);
case "correo":
return (
<>
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px',textAlign:'left' }}>
<div>
<strong style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra',textAlign:'left', fontWeight:'normal'}}>
{doc.correoElectronico}
</strong></div>
</div>
</>
);
case "creador": 
return (
<>
<div style={{color: '#2c2c2c', fontSize:'13px', fontFamily:'Effra'}}>
Creado por:
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{doc.creador || "-"}</p>
<p style={{color:'#999', margin:'0', fontSize:'13px'}}>{formatDateTime(doc.fechaCreacion)}</p>
</div>
</>
);
default:
return null;
}
};
return (
<>
<div
ref={ref}
style={{ display: "inline-block" }}
onMouseEnter={handleMouseEnter}
onMouseLeave={handleMouseLeave}
>
{children}
</div>
{isHovered && (
<div
style={{
position: "absolute",
top: coords.top,
backgroundColor: "#f9fafd",
padding: "8px 12px",
borderRadius: "4px",
whiteSpace: "normal",
zIndex: 1000,
fontSize: "14px",
minWidth: "200px",
pointerEvents: "none",
boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
}}
>
{renderContent()}
</div>
)}
</>
);
};
const Compras = () => {
const [compras, setCompras] = useState(comprasCache?.compras || []);
const [ordenes, setOrdenes] = useState(comprasCache?.ordenes || []);
const [recientes, setRecientes] = useState(comprasCache?.recientes || []);
const [loading, setLoading] = useState(!comprasCache);
// Cotización del día para sumar/ordenar compras cargadas en distintas divisas
// como si fueran todas Pesos (antes solo se convertía Dólares).
const { cotizaciones } = useCotizaciones();
const [anulando, setAnulando] = useState(null);
const [compraAAnular, setCompraAAnular] = useState(null);
const [motivoAnulacion, setMotivoAnulacion] = useState('');
const [errorAnulacion, setErrorAnulacion] = useState('');
const [sortField, setSortField] = useState('');
const [sortOrder, setSortOrder] = useState('asc');
const handleSort = (field) => {
if (sortField === field) {
setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
} else {
setSortField(field);
setSortOrder('asc');
}
};
const [categoriaSeleccionada, setCategoriaSeleccionada] = useState("Activos");
const simbolosDivisa = {
Pesos: "$",
Dólares: "U$S",
Reales: "R$",
Euros: "€",
};
const opcionesPeriodoCompras = [
{ id: "semanal", label: "Monto total semanal" },
{ id: "mensual", label: "Monto total mensual" },
{ id: "trimestral", label: "Monto total trimestral" },
{ id: "semestral", label: "Monto total semestral" },
{ id: "anual", label: "Monto total anual" },
{ id: "historico", label: "Monto total histórico" },
];
const [periodoCompra, setPeriodoCompra] = useState(opcionesPeriodoCompras[5]);
const calcularMontoCompras = (compras, periodo) => {
const ahora = new Date();
const filtrarPorPeriodo = (compra) => {
if (!compra.fechaEntrega) return false;
const fecha = new Date(compra.fechaEntrega);
if (isNaN(fecha)) return false;
switch (periodo.id) {
case "semanal":
const primerDiaSemana = new Date(ahora);
primerDiaSemana.setDate(ahora.getDate() - ahora.getDay());
primerDiaSemana.setHours(0, 0, 0, 0);
const ultimoDiaSemana = new Date(primerDiaSemana);
ultimoDiaSemana.setDate(primerDiaSemana.getDate() + 6);
ultimoDiaSemana.setHours(23, 59, 59, 999);
return fecha >= primerDiaSemana && fecha <= ultimoDiaSemana;
case "mensual":
return (
fecha.getMonth() === ahora.getMonth() &&
fecha.getFullYear() === ahora.getFullYear()
);
case "trimestral":
return (
fecha.getFullYear() === ahora.getFullYear() &&
Math.floor(fecha.getMonth() / 3) ===
Math.floor(ahora.getMonth() / 3)
);
case "semestral":
return (
fecha.getFullYear() === ahora.getFullYear() &&
Math.floor(fecha.getMonth() / 6) ===
Math.floor(ahora.getMonth() / 6)
);
case "anual":
return fecha.getFullYear() === ahora.getFullYear();
case "historico":
default:
return true;
}
};
return compras
.filter(filtrarPorPeriodo)
.reduce((total, compra) => {
if (isNaN(parseFloat(compra.totalConImpuestos))) return total;
return total + aPesos(compra.totalConImpuestos, compra.tipoDivisa, cotizaciones);
}, 0);
};
const montoCompras = calcularMontoCompras(compras, periodoCompra);
const navigate = useNavigate();
const handleRealizarCompra = (ordenDeCompra) => {
navigate("/nueva-compra", { state: { ordenDeCompra } });
};
const handleDownloadOrdenCompra = async (docId) => {
try {
const storageRef = ref(storage, `facturas_compra/${docId}.pdf`);
const url = await getDownloadURL(storageRef);
window.open(url, "_blank");
} catch (error) {
console.error("Error al descargar el archivo:", error);
if (error.code === "storage/object-not-found") {
alert("El archivo de la orden de compra no fue encontrado.");
} else {
alert(
"Ocurrió un error al intentar descargar el archivo. Por favor, inténtelo de nuevo más tarde."
);
}
}
};
const handleDownloadPdf = (url) => {
if (url) {
window.open(url, "_blank");
} else {
alert("No hay archivo adjunto para esta compra.");
}
};
const fetchData = async () => {
try {
const comprasSnap = await getDocs(collection(db, "compras"));
const comprasData = comprasSnap.docs.map((doc) => ({
id: doc.id,
...doc.data(),
}));
const ordenadasCompras = [...comprasData].sort((a, b) => {
if (a.fechaEntrega && b.fechaEntrega) {
return new Date(b.fechaEntrega) - new Date(a.fechaEntrega);
}
return b.id.localeCompare(a.id);
});
const ordenesSnap = await getDocs(collection(db, "ordenes_compra"));
const ordenesData = await Promise.all(
ordenesSnap.docs.map(async (doc) => {
const data = { id: doc.id, ...doc.data() };
try {
const storageRef = ref(storage, `facturas_compra/${doc.id}.pdf`);
await getDownloadURL(storageRef);
data.tienePdf = true;
} catch {
data.tienePdf = false;
}
return data;
})
);
setCompras(ordenadasCompras);
setOrdenes(ordenesData);
const todas = [...ordenadasCompras, ...ordenesData];
const recientesOrdenadas = todas.sort((a, b) => {
const fa = a.fechaCreacion?.toDate?.() || new Date(a.fechaCreacion || 0);
const fb = b.fechaCreacion?.toDate?.() || new Date(b.fechaCreacion || 0);
return fb - fa;
});
const recientesFinal = recientesOrdenadas.slice(0, 4);
setRecientes(recientesFinal);
// Se guarda para que la próxima vez que se entre a esta pantalla (ej.
// volviendo de guardar una compra) se muestre esta lista al toque, en vez
// de tapar todo con el spinner mientras se recarga en segundo plano.
comprasCache = { compras: ordenadasCompras, ordenes: ordenesData, recientes: recientesFinal };
} catch (error) {
console.error("Error al traer datos:", error);
} finally {
setLoading(false);
}
};
useEffect(() => {
fetchData();
}, []);
// Anular = devolverle al stock lo que esta compra sumó, y dejar el documento
// marcado (no se borra). Es la salida cuando se cargó mal una cantidad o un
// precio, o la misma factura dos veces.
// Anular = devolverle al stock lo que esta compra sumó, y dejar el documento
// marcado (no se borra). Es la salida cuando se cargó mal una cantidad o un
// precio, o la misma factura dos veces. La confirmación va por el modal
// compartido (ConfirmationModal), no por los carteles nativos del navegador.
const handleAnularCompra = async () => {
if (!compraAAnular) return;
try {
setAnulando(compraAAnular.id);
const user = getAuth().currentUser;
if (!user) throw new Error('Debés iniciar sesión.');
const idToken = await user.getIdToken();
const res = await fetch(`https://backend-288175208699.europe-west1.run.app/anular-compra/${encodeURIComponent(compraAAnular.id)}`, {
method: 'POST',
headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
body: JSON.stringify({ motivo: motivoAnulacion }),
});
const data = await res.json();
if (!res.ok) throw new Error(data.error || 'No se pudo anular la compra.');
setCompraAAnular(null);
setMotivoAnulacion('');
await fetchData();
} catch (err) {
setErrorAnulacion(err.message);
} finally {
setAnulando(null);
}
};
if (loading) return <LoadingSpinner />;
const formatearFecha = (fecha) => {
if (!fecha) return "-";
const date = fecha.toDate ? fecha.toDate() : new Date(fecha);
return `El ${date.toLocaleDateString("es-AR")} a las ${date.toLocaleTimeString("es-AR", {
hour: "2-digit",
minute: "2-digit",
hour12: false,
})}`;
};
const formatearFechaEntrega = (fechaStr) => {
if (!fechaStr) return "-";
const date = new Date(fechaStr + "T00:00:00");
if (isNaN(date)) return fechaStr;
return date.toLocaleDateString("es-AR", {
day: "2-digit",
month: "2-digit",
year: "numeric",
});
};
// En Servicios se muestra la fecha que esté cargada; si hay más de una,
// prioridad: fecha de pago > fecha de emisión (fechaCompra) > fecha de
// vencimiento (fechaEntrega).
const obtenerFechaColumna = (doc, categoria) => {
if (categoria === "Servicios") {
return doc.fechaPago || doc.fechaCompra || doc.fechaEntrega;
}
return doc.fechaEntrega;
};
const comprasFiltradas =
categoriaSeleccionada === "Órdenes de compra"
? ordenes
: compras.filter((compra) =>
categoriaSeleccionada === "Todos"
? true
: compra.articulos?.some(
(articulo) => articulo.categoria === categoriaSeleccionada
)
);
let comprasOrdenadas = [...comprasFiltradas];
if (sortField) {
comprasOrdenadas.sort((a, b) => {
let aValue, bValue;
switch (sortField) {
case 'id':
case 'numeroFactura':
aValue = a.id || '';
bValue = b.id || '';
return sortOrder === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
case 'fechaEntrega':
// Se ordena por la misma fecha que se muestra en la columna: en Servicios
// es la prioridad pago→emisión→vencimiento (obtenerFechaColumna), en el
// resto es fechaEntrega. Antes ordenaba siempre por fechaEntrega y en
// Servicios el orden no coincidía con lo que se veía.
aValue = new Date(obtenerFechaColumna(a, categoriaSeleccionada) || 0).getTime();
bValue = new Date(obtenerFechaColumna(b, categoriaSeleccionada) || 0).getTime();
break;
case 'totalConImpuestos':
aValue = aPesos(a.totalConImpuestos, a.tipoDivisa, cotizaciones);
bValue = aPesos(b.totalConImpuestos, b.tipoDivisa, cotizaciones);
break;
case 'montoEstimado':
aValue = parseFloat(a.montoEstimado) || 0;
bValue = parseFloat(b.montoEstimado) || 0;
break;
case 'servicio':
// Mismo valor que se muestra en la columna Servicio: "Transporte" para los
// envíos (tienen ventaId), o el nombre del artículo para el resto.
aValue = (a.ventaId ? 'Transporte' : (a.articulos?.[0]?.nombre || '')).toLowerCase();
bValue = (b.ventaId ? 'Transporte' : (b.articulos?.[0]?.nombre || '')).toLowerCase();
break;
case 'razonSocial':
aValue = a.razonSocial || '';
bValue = b.razonSocial || '';
break;
case 'tipoFactura':
aValue = a.tipoFactura || '';
bValue = b.tipoFactura || '';
break;
case 'fechaCreacion':
aValue = new Date(a.fechaCreacion).getTime();
bValue = new Date(b.fechaCreacion).getTime();
break;
default:
return 0;
}
if (aValue < bValue) return sortOrder === 'asc' ? -1 : 1;
if (aValue > bValue) return sortOrder === 'asc' ? 1 : -1;
return 0;
});
}
return (
<div className="Trazabilidad">
<header className="trazabilidad-header">
<div className="header-content">
<h1>Compras</h1>
</div>
</header>
{compras.length === 0 && ordenes.length === 0 ? (
<EmptyState label="compras" />
) : (
<div className="trazabilidad-content">
<div className="section">
<h2>Recientes</h2>
{recientes.length === 0 ? (
<p>No hay documentos recientes</p>
) : (
<div className="recent-grid">
{recientes.map((doc) => (
<div
key={doc.id}
className="document-card recent-card"
onClick={() => {
if (doc.numeroOrden) {
setCategoriaSeleccionada("Órdenes de compra");
} else if (doc.articulos && doc.articulos.length > 0) {
setCategoriaSeleccionada(doc.articulos[0].categoria);
}
}}
style={{
flexDirection: "column",
textAlign: "left",
alignItems: "start",
justifyContent: "start",
gap: "2px",
cursor: "pointer"
}}
>
<span className="doc-id" style={{ margin: 0 }}>
{doc.id}
</span>
<p className="card-creator" style={{ margin: 0 }}>
{doc.creador || "Sin creador"}
</p>
<p className="card-date" style={{ margin: 0 }}>
{formatearFecha(doc.fechaCreacion)}
</p>
</div>
))}
</div>
)}
</div>
<div className="monto-historico" style={{marginBottom:'15px'}}>
<div className="input-group">
<Listbox value={periodoCompra} onChange={setPeriodoCompra}>
{({ open }) => (
<>
<ListboxButton className={`monto-listbox-button ${open ? 'open' : ''}`}>
{periodoCompra.label}
<span className="monto-arrow-container">
<span className="monto-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="monto-listbox-options">
{opcionesPeriodoCompras.map((op) => (
<ListboxOption key={op.id} value={op} className="monto-listbox-option">
{op.label}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<p style={{ margin: "0" }}>
${montoCompras.toLocaleString('es-AR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
</p>
</div>
<div className="section">
<ul className="compras-tabs">
{categorias.map((cat) => (
<li
key={cat}
className={categoriaSeleccionada === cat ? "active" : ""}
>
<a
href="#"
onClick={(e) => {
e.preventDefault();
setCategoriaSeleccionada(cat);
}}
>
{cat}
</a>
</li>
))}
</ul>
{comprasOrdenadas.length === 0 ? (
<p></p>
) : (
<div className="table-container">
<table className="table-full">
<thead>
{categoriaSeleccionada === "Órdenes de compra" ? (
<tr>
{/* Columna del lapicito: sin encabezado, del ancho del ícono. */}
<th className="col-editar"></th>
<th onClick={() => handleSort('id')} style={{ cursor: 'pointer' , fontSize:'14px'}}>
Código N° {sortField === 'id' && <span className={`arrow ${sortOrder}`}></span>}
</th>
<th onClick={() => handleSort('razonSocial')} style={{ cursor: 'pointer' , fontSize:'14px'}}>
Proveedor {sortField === 'razonSocial' && <span className={`arrow ${sortOrder}`}></span>}
</th>
<th onClick={() => handleSort('montoEstimado')} style={{ cursor: 'pointer' , fontSize:'14px'}}>
Monto estimado {sortField === 'montoEstimado' && <span className={`arrow ${sortOrder}`}></span>}
</th>
<th style={{ cursor: 'default' ,  fontSize:'14px'}}>Documento</th>
<th style={{ cursor: 'default',  fontSize:'14px' }}>Estado</th>
</tr>
) : (
<tr>
{/* Columna del lapicito: sin encabezado, igual que la de Documento. */}
<th className="col-editar"></th>
<th onClick={() => handleSort('id')} style={{ cursor: 'pointer' , fontSize:'14px'}}>
Factura N° {sortField === 'id' && <span className={`arrow ${sortOrder}`}></span>}
</th>
{/* En Servicios cada compra es una sola factura de un solo servicio (luz,
    gas, internet, flete...): se muestra su nombre para poder distinguirlas
    de un vistazo. */}
{categoriaSeleccionada === "Servicios" && (
<th onClick={() => handleSort('servicio')} style={{ cursor: 'pointer', fontSize:'14px' }}>
Servicio {sortField === 'servicio' && <span className={`arrow ${sortOrder}`}></span>}
</th>
)}
<th onClick={() => handleSort('fechaEntrega')} style={{ cursor: 'pointer' , fontSize:'14px'}}>
{categoriaSeleccionada === "Servicios" ? "Fecha" : "Fecha de entrega"} {sortField === 'fechaEntrega' && <span className={`arrow ${sortOrder}`}></span>}
</th>
<th onClick={() => handleSort('razonSocial')} style={{ cursor: 'pointer' , fontSize:'14px'}}>
Proveedor {sortField === 'razonSocial' && <span className={`arrow ${sortOrder}`}></span>}
</th>
<th onClick={() => handleSort('totalConImpuestos')} style={{ cursor: 'pointer' , fontSize:'14px'}}>
{categoriaSeleccionada === "Servicios" ? "Monto" : "Valor de compra"} {sortField === 'totalConImpuestos' && <span className={`arrow ${sortOrder}`}></span>}
</th>
<th style={{ cursor: 'default', fontSize:'14px' }}>Documento</th>
{/* Columna de anular: sin encabezado. */}
<th className="col-anular"></th>
</tr>
)}
</thead>
<tbody>
{comprasOrdenadas.map((doc) =>
categoriaSeleccionada === "Órdenes de compra" ? (
<tr key={doc.id}>
    {/* Columna propia del lapicito. Una orden ya finalizada se convirtió en
        compra (se edita la compra, no la orden): ahí la celda queda vacía,
        pero se mantiene para que las columnas no se corran. */}
    <td className="col-editar">
        {doc.estado !== 'finalizada' && (
        <button
            onClick={(e) => { e.stopPropagation(); navigate(`/ordenes-compra/editar/${doc.id}`); }}
            title="Editar orden de compra"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'inline-flex', alignItems: 'center' }}
        >
            <EditIcon style={{ width: '16px', height: '16px' }} />
        </button>
        )}
    </td>
    <td style={{cursor:'default'}}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
        <Tooltip
            doc={doc}
            type="creador"
            delay={50}
            offsetX={-50}
            offsetY={0}
        >
            <span style={{ cursor: 'default' }}>
                {doc.id}
            </span>
        </Tooltip>
        </div>
    </td>
<td>{doc.razonSocial || "-"}</td>
    <td style={{ textAlign: 'right', paddingRight: '70px' }}>
        {simbolosDivisa[doc.tipoDivisa] || "$"} { " " }
        {(parseFloat(doc.montoEstimado) || 0).toLocaleString("es-AR", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        })}
    </td>
<td>
<div
onClick={doc.tienePdf ? () => handleDownloadOrdenCompra(doc.id) : null}
style={{
cursor: doc.tienePdf ? "pointer" : "default",
}}
>
<FileIcon
style={{
height: "20px",
margin: "auto",
opacity: doc.tienePdf ? 1 : 0.5,
overflow: "visible",
}}
/>
</div>
</td>
<td>
{doc.estado === 'finalizada' ? (
<button
className="button finalizado"
disabled
style={{ width: 'fit-content', fontSize:'14px' }}
>
Finalizada
</button>
) : (
<button
onClick={() => handleRealizarCompra(doc)}
className="button compra"
style={{ width: 'fit-content' }}
>
Cargar compra
</button>
)}
</td>
</tr>
) : (
<tr className="table-row" key={doc.id} style={{cursor:'default', opacity: doc.anulada ? 0.55 : 1}}>
    {/* Columna propia del lapicito. Si está anulada no hay botón, pero la
        celda queda igual para que las columnas no se corran. */}
    <td className="col-editar">
        {!doc.anulada && (
        <button
            onClick={(e) => {
                e.stopPropagation();
                // Los gastos de envío en Servicios son un espejo automático de la
                // venta (ver sincronizar_compra_envio en el backend): editarlos acá
                // no sirve de nada, la próxima vez que se guarde la venta se pisan
                // solos. La fuente real es la venta, así que se edita ahí.
                if (doc.ventaId) {
                    navigate(`/ventas/editar/${doc.ventaId}`);
                } else {
                    navigate(`/compras/editar/${doc.id}`);
                }
            }}
            title={doc.ventaId ? 'Editar venta' : 'Editar compra'}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'inline-flex', alignItems: 'center' }}
        >
            <EditIcon style={{ width: '16px', height: '16px' }} />
        </button>
        )}
    </td>
    <td style={{cursor:'default'}}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
        <Tooltip
            doc={doc}
            type="creador"
            delay={50}
            offsetX={-50}
            offsetY={0}
        >
            <span style={{ cursor: 'default', textDecoration: doc.anulada ? 'line-through' : 'none' }}>
                {/* El doc id de un envío es "envio-{idVenta}"; el prefijo es interno
                    (idempotencia, ver sincronizar_compra_envio), así que se muestra
                    pelado — queda el id de la venta a la que corresponde el flete. */}
                {doc.ventaId ? doc.id.replace(/^envio-/, '') : doc.id}
            </span>
        </Tooltip>
        </div>
    </td>
{categoriaSeleccionada === "Servicios" && (
<td style={{
maxWidth: "120px",
overflow: "hidden",
textOverflow: "ellipsis",
whiteSpace: "nowrap",
textAlign: "center",
}}>{doc.ventaId ? "Transporte" : (doc.articulos?.[0]?.nombre || "-")}</td>
)}
<td>{formatearFechaEntrega(obtenerFechaColumna(doc, categoriaSeleccionada))}</td>
<td style={{
maxWidth: "70px",
overflow: "hidden",
textOverflow: "ellipsis",
whiteSpace: "nowrap",
textAlign: "center",
margin: 0,
}}>{doc.razonSocial || "-"}</td>
<td style={{ textAlign: 'right', paddingRight:'70px' }}>
{simbolosDivisa[doc.tipoDivisa] || "$"}{" "}
{(parseFloat(doc.totalConImpuestos) || 0).toLocaleString("es-AR", {
minimumFractionDigits: 0,
maximumFractionDigits: 0,
})}
</td>
<td>
<div
onClick={doc.url_factura_pdf ? () => handleDownloadPdf(doc.url_factura_pdf) : null}
style={{ cursor: doc.url_factura_pdf ? 'pointer' : 'default' }}
>
<FileIcon style={{ height: "20px", margin: "auto", opacity: doc.url_factura_pdf ? 1 : 0.5, overflow:'visible' }} />
</div>
</td>
{/* Anular: última columna. Si ya está anulada, la celda queda vacía. */}
<td className="col-anular">
{!doc.anulada && (
<button
className="btn-anular"
onClick={(e) => { e.stopPropagation(); setCompraAAnular(doc); setMotivoAnulacion(''); }}
title="Anular compra (devuelve al stock lo que sumó)"
>
{/* La × dibujada, no el caracter: así el grosor lo define strokeWidth
    y no la tipografía (que la renderizaba muy pesada). */}
<svg viewBox="0 0 24 24" width="14" height="14" fill="none"
     stroke="currentColor" strokeWidth="2" strokeLinecap="round">
<line x1="5" y1="5" x2="19" y2="19" />
<line x1="19" y1="5" x2="5" y2="19" />
</svg>
</button>
)}
</td>
</tr>
)
)}
</tbody>
</table>
</div>
)}
</div>
</div>
)}

<ConfirmationModal
isVisible={!!compraAAnular}
message={`¿Anular la compra ${compraAAnular?.id}?`}
detalle="Se le va a devolver al stock todo lo que esta compra sumó. La compra no se borra: queda tachada en el listado. Después podés cargarla de nuevo con los datos correctos."
inputLabel="Motivo de la anulación (opcional)"
inputValue={motivoAnulacion}
onInputChange={setMotivoAnulacion}
textoConfirmar="Anular compra"
textoCancelar="Volver"
peligro
ocupado={anulando === compraAAnular?.id}
onConfirm={handleAnularCompra}
onCancel={() => { setCompraAAnular(null); setMotivoAnulacion(''); }}
/>

<ConfirmationModal
isVisible={!!errorAnulacion}
message="No se pudo anular la compra"
detalle={errorAnulacion}
textoConfirmar="Entendido"
textoCancelar="Cerrar"
onConfirm={() => setErrorAnulacion('')}
onCancel={() => setErrorAnulacion('')}
/>
</div>
);
};
export default Compras;